export default __webpack_public_path__ + "static/media/miguel-lopes-19.dbf20b5a.jpg";